import { render, staticRenderFns } from "./FormularioEliminarCuenta.vue?vue&type=template&id=4b57ca21&scoped=true&"
import script from "./FormularioEliminarCuenta.vue?vue&type=script&lang=js&"
export * from "./FormularioEliminarCuenta.vue?vue&type=script&lang=js&"
import style0 from "./FormularioEliminarCuenta.vue?vue&type=style&index=0&id=4b57ca21&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b57ca21",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VContainer,VForm,VTextField,VTextarea})
